import { LayerKind } from "@/shared/plan/layerKind";
import type { CatalogSection } from "../../types";
import { BaseboardId } from "./ids";
import { BaseboardMaterial, type BaseboardCatalogItem } from "./types";

export const legacyBlackAluminum: BaseboardCatalogItem = {
	id: BaseboardId.BlackAluminum,
	material: BaseboardMaterial.BlackAluminum,
	subGroup: "Алюминий",
	name: "Алюминиевый чёрный",
	description: "Накладной плинтус из чёрного анодированного алюминия.",
	color: "#34383b",
	height: 60,
	depth: 10,
	metalness: 0.6,
};

export const baseboardSection: CatalogSection<BaseboardCatalogItem> = {
	kind: LayerKind.Baseboard,
	label: "Плинтус",
	canChangeDimensions: false,
	subGroups: ["ПВХ", "Дерево", "МДФ", "Алюминий", "Теневой"],
	items: [
		{
			id: BaseboardId.WhitePvc,
			material: BaseboardMaterial.WhitePvc,
			subGroup: "ПВХ",
			name: "Белый ПВХ",
			description: "Влагостойкий белый плинтус.",
			color: "#f8fafc",
			height: 80,
			depth: 14,
		},
		{
			id: BaseboardId.OakWood,
			material: BaseboardMaterial.OakWood,
			subGroup: "Дерево",
			name: "Дубовый",
			description: "Деревянный плинтус с тёплой текстурой дуба.",
			color: "#9a6b46",
			height: 100,
			depth: 18,
		},
		{
			id: BaseboardId.GrayMdf,
			material: BaseboardMaterial.GrayMdf,
			subGroup: "МДФ",
			name: "Серый МДФ",
			description: "Окрашенный МДФ для современного интерьера.",
			color: "#64748b",
			height: 100,
			depth: 16,
		},
		{
			id: BaseboardId.Aluminum,
			material: BaseboardMaterial.Aluminum,
			subGroup: "Алюминий",
			name: "Алюминиевый",
			description: "Накладной плинтус из светлого алюминия.",
			color: "#a9b0b4",
			height: 60,
			depth: 10,
			metalness: 0.6,
		},
		{
			id: BaseboardId.Shadow,
			material: BaseboardMaterial.Shadow,
			subGroup: "Теневой",
			name: "Теневой",
			description: "Встроенный профиль с углублением у основания стены.",
			color: "#292d30",
			height: 40,
			depth: 10,
			metalness: 0.4,
			recessed: true,
		},
	],
};
